module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"description":"Limite máximo de chaves atendidas: {0}. Para criar novas chaves é necessário deletar chaves antigas."},"en-US":{"description":"Limite máximo de chaves atendidas: {0}. Para criar novas chaves é necessário deletar chaves antigas."}}')
  delete Component.options._Ctor
}
